import Vue from "vue";
/* v-loading: 页面loading指令 */
Vue.directive("loading", {
    bind: (el, binding) => {
        const tempDiv = document.createElement("div");
        tempDiv.className = "page-loading";
        el.loadingElement = tempDiv;
        if (binding.value) el.appendChild(tempDiv);
    },
    update: (el, binding) => {
        if (binding.value) {
            if (el.loadingElement.parentNode === null)
                el.appendChild(el.loadingElement);
        } else {
            if (el.loadingElement.parentNode === el)
                el.removeChild(el.loadingElement);
        }
    },
    unbind: (el) => {
        if (el.loadingElement.parentNode === el)
            el.removeChild(el.loadingElement);
        el.loadingElement = null;
    },
});
